var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 27H27V54H31.5V27Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27H40.5V54H45V27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5V18H13.5V63C13.5 64.1935 13.9741 65.3381 14.818 66.182C15.6619 67.0259 16.8065 67.5 18 67.5H54C55.1935 67.5 56.3381 67.0259 57.182 66.182C58.0259 65.3381 58.5 64.1935 58.5 63V18H63V13.5H9ZM18 63V18H54V63H18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 4.5H27V9H45V4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic-trash.fa9c2f0c79950d4c8a6a87783a8acd81.svg";
export { ForwardRef as ReactComponent };